import styled from 'styled-components'

export const PulseSurveys = styled.div`
    display: flex;
    position: relative;
`

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 24px;
`
